(() => {
  const root = document.getElementById('ship-product-form-main');
  if (!root) return;

  const form = root.querySelector('product-form[data-name="main-product-form"]');
  if (!form) return;

  const getButton = () => form.querySelector('.custom-bis-trigger');

  const updateButton = (variant) => {
    const button = getButton();
    if (!button) return;

    const isSoldOut = variant?.available === false;
    button.hidden = !isSoldOut;
    button.dataset.variantId = variant?.id ?? '';
    button.textContent = variant
      ? `${variant.title}の再入荷通知を受け取る`
      : '再入荷通知を受け取る';
  };

  // 商品フォームのブロックは初期表示後にテンプレートから追加される。
  const initialize = () => {
    if (!getButton() || !('currentVariant' in form)) return;
    observer.disconnect();
    updateButton(form.allOptionsChosen ? form.currentVariant : null);
  };
  const observer = new MutationObserver(initialize);
  observer.observe(form, { childList: true, subtree: true });
  initialize();

  document.addEventListener('ARMADA:VARIANT:CHANGE', (event) => {
    const { productId, scopeId, variant } = event.detail || {};
    if (String(productId) !== root.dataset.productId || String(scopeId) !== root.dataset.scopeId) return;
    updateButton(variant);
  });

  // 未選択や存在しない組み合わせでは、フォーム側が変更イベントを発行しない。
  form.addEventListener('change', (event) => {
    if (!event.target.matches('[data-name="product-option-radio"], [data-name="product-option-select"]')) return;
    queueMicrotask(() => updateButton(form.allOptionsChosen ? form.currentVariant : null));
  });

  root.addEventListener('click', (event) => {
    const button = event.target.closest('.custom-bis-trigger');
    if (!button || !form.contains(button)) return;
    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (button.hidden || !variantId) return;

    if (window.AmpBIS && typeof window.AmpBIS.openWidget === 'function') {
      window.AmpBIS.openWidget({ variantId });
    } else if (window.bkNotifyWidget && typeof window.bkNotifyWidget.showNotifyMe === 'function') {
      window.bkNotifyWidget.showNotifyMe(variantId);
    } else {
      console.error('AMP Back in Stock widget not loaded');
    }
  });
})();
